import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Threats } from '../../core/store/threats/models/Threats';

@Injectable({
  providedIn: 'root',
})
export class ThreatsService {
  private baseApiUrl: string = environment.API_BASE_URL;

  constructor(private readonly http: HttpClient) {}

  getThreats(): Observable<Threats[]> {
    return this.http.get<Threats[]>(`${this.baseApiUrl}/threats`);
  }

  runScan(): Observable<Threats[]> {
    return this.http.post<Threats[]>(
      `${this.baseApiUrl}/threats/run-threats-scan`,
      {},
    );
  }

  calculateThreatRisk(threatId: string): Observable<Threats[]> {
    return this.http.post<Threats[]>(
      `${this.baseApiUrl}/threats/calculate-risk`,
      {
        threatId,
      },
    );
  }
}
